export const DEFAULT_COLUMN = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'is_active',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: true,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: true,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
]

export const MCI_COLUMN = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'is_active',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: true,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: true,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
]